import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import Link from 'next/link';
import React, { useCallback } from 'react';
import Typography from '@ui/Typography';
import { getCoreEditorRef } from '../../../context/editorV2/CoreEditorContext';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { setReplacementsState } from '../../../store/ReplacementsSlice';
import Switch from '../../Inputs/Switch';

const useStyles = makeStyles()(theme => ({
  heading: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
    textTransform: 'uppercase',
  },
  text: {
    lineHeight: 1,
  },
}));

const PhoneticReplacementsSwitch = () => {
  const coreEditorRef = getCoreEditorRef();
  const replacementsState = useAppSelector(appState => appState.replacements);
  const {
    replacedWordsCount,
    replacementsEnabled,
    replacementsLibraryLoading,
  } = replacementsState;
  const appDispatch = useAppDispatch();
  const { classes } = useStyles();

  const onClick = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event: any) => {
      const toggledValue = !!event.target.checked;
      coreEditorRef?.commands.togglePhoneticReplacements(toggledValue);

      appDispatch(setReplacementsState({ replacementsEnabled: toggledValue }));
    },
    [appDispatch, coreEditorRef]
  );

  return (
    <Box mb="24px">
      <Box display="flex" justifyContent="space-between">
        <Typography variant="h5" component="h5" bold>
          Replacements
        </Typography>
        <Box className={classes.heading}>
          <Switch
            disabled={replacementsLibraryLoading}
            checked={replacementsEnabled}
            onClick={onClick}
            inputProps={{
              'aria-labelledby': 'pronunciationHeader',
              role: 'switch',
            }}
          />
        </Box>
      </Box>
      <Link href="/dashboard/phonetic" passHref>
        <Typography variant="pSm" color="secondary">
          {`${replacedWordsCount} word${
            replacedWordsCount !== 1 ? 's' : ''
          } replaced`}
        </Typography>
      </Link>
    </Box>
  );
};

export default PhoneticReplacementsSwitch;
